export default __webpack_public_path__ + "static/media/Logo 500x500 PNG (WO- BG).png.06602489.png";